export const CONSTANTS = {
  REQUIRED: 'REQUIRED',
  OPTIONAL: 'OPTIONAL',
  DISABLED: 'DISABLED',
  ENABLED: 'ENABLED',
} as const;
